import type { CSSProperties } from 'react';

/** Fixed panel under the inline Flow orb — shared by FlowContext (click-time) and FlowWidget (scroll/resize). */
export function computePanelAnchorStyle(
  anchorEl: HTMLElement | null,
  vw: number,
  vh: number
): CSSProperties | undefined {
  if (!anchorEl || !vw) return undefined;
  const r = anchorEl.getBoundingClientRect();
  const gap = 8;
  const margin = 12;
  const panelWidth = Math.min(392, vw - 2 * margin);
  let left = r.left;
  if (left + panelWidth > vw - margin) left = Math.max(margin, vw - margin - panelWidth);
  if (left < margin) left = margin;
  const top = r.bottom + gap;
  const maxH = Math.min(560, Math.max(220, vh - top - margin));
  return {
    position: 'fixed',
    top,
    left,
    zIndex: 50,
    width: panelWidth,
    height: maxH,
    maxHeight: maxH,
    transformOrigin: 'top left',
  };
}
